import { render, staticRenderFns } from "./integral-buy-record.vue?vue&type=template&id=214df423"
import script from "./integral-buy-record.vue?vue&type=script&lang=ts"
export * from "./integral-buy-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports